import PropTypes from 'prop-types';
import { Text, ActionIcon, Group } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';
import s3Mutations from '@/api/mutitations/s3';
import { downloadFile } from '@/helpers/download';

const DownloadFile = ({ file }) => {
  const { useDownload } = s3Mutations;
  const { mutateAsync: downloadMutate } = useDownload();

  if (!file) return null;

  const { path, name } = file;

  const downloadFileByPath = async () => {
    try {
      const response = await downloadMutate({ path });
      const { file: fileData, contentType } = response;
      downloadFile(fileData, name, contentType);
    } catch (error) {
      // TO DO SOMETHING
    }
  };

  return (
    <Group mb={8} dir="ltr">
      <ActionIcon c={'black'} variant="light" onClick={downloadFileByPath}>
        <IconDownload size={20} />
      </ActionIcon>
      <Text c={'black'} size='sm'>{name}</Text>
    </Group>
  );
};

DownloadFile.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
  }),
};

export default DownloadFile;
